(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurveResultsOpen', YieldCurveResultsOpen);

    YieldCurveResultsOpen.$inject = ['$resource', 'DateUtils'];

    function YieldCurveResultsOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/yield-curve-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
